module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Will Jordan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Will Jordan’s Ryan Drake novels draw on extensive research into weapons and tactics, as well as the experiences of men who’ve fought in some of the world’s most daunting combat zones. Other books in the series include Redemption, Sacrifice and Betrayal. He lives in Fife, Scotland, with his wife and sons.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Psg87X/tc-custom/9781910859735.jpg?1726519205865",
      "alt": "This image is the cover for the book Downfall, Ryan Drake"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Downfall, Ryan Drake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A British Army veteran turned CIA agent races around the world to catch someone killing in his name in this action-packed thriller.")])]), _c('p', [_vm._v(" Ryan Drake and his team are in hiding, having become sworn enemies of states and agencies around the world. But when a CIA operative and former adversary is killed in a car bomb attack, Drake is shocked to hear someone claiming responsibility using his name. ")]), _c('p', [_vm._v(" Forced out of hiding by this mysterious new threat, Drake embarks alone on a dangerous and deadly search for answers; a journey that will take him from the slums of Rio to the deserts of Tunisia and the mountains of Afghanistan. But as the stranger’s insidious influence grows stronger, he begins to realize the key to unravelling the present lies in his own shadowy past. ")]), _c('p', [_vm._v(" Following his trail of destruction, the team must fight to save Drake not only from a list of ruthless enemies, but even more urgently, from himself. ")]), _c('p', [_c('b', [_vm._v("Perfect for fans of Lee Child, David Baldacci, and Vince Flynn.")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0